const constants = {
  defaultDateFormat: "DD/MM/YYYY",
  defaultHourFormat: "HH:mm [h]",
  orderBy: {
    asc: "asc",
    desc: "desc",
  },
  orderMode: {
    SERVIDOR: "SERVIDOR",
    LOCAL: "LOCAL",
  },
};

export default constants;
